import React from "react";
import { Link } from "react-router-dom";
import { getSortedStories } from "@/data/testimonialStories";

export default function TestimonialsHighlight({
  testIdPrefix,
  sectionClassName = "py-14 md:py-20 bg-tinted",
}) {
  const stories = getSortedStories().slice(0, 3);
  if (stories.length === 0) return null;

  return (
    <section
      data-testid={`${testIdPrefix}-testimonials-highlight`}
      className={`relative px-5 md:px-10 border-t border-hairline ${sectionClassName}`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <p className="text-[12px] tracking-[0.35em] uppercase text-gold mb-5 font-body">
            — Visszajelzések
          </p>
          <h2 className="font-serif-display text-[28px] sm:text-[32px] md:text-[36px] leading-[1.25] text-graphite max-w-2xl mx-auto">
            Akik már megtapasztalták
            <br className="hidden md:block" />{" "}
            a{" "}
            <em className="text-gold" style={{ fontStyle: "italic" }}>
              közös folyamatot
            </em>
            …
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {stories.map((story) => {
            const items = story.items || [];
            const coverIdx = story.coverIndex ?? 0;
            const cover = items[coverIdx];
            const coverSrc = cover?.type === "video" ? cover.poster : cover?.src;
            return (
              <Link
                key={story.id}
                to="/visszajelzesek"
                data-testid={`${testIdPrefix}-testimonial-${story.id}`}
                className="group flex flex-col bg-warm border border-hairline hover:border-gold transition-colors duration-300 overflow-hidden"
                style={{ boxShadow: "0 10px 40px -32px rgba(160, 122, 40, 0.3)" }}
              >
                <div className="relative overflow-hidden" style={{ aspectRatio: "4 / 5" }}>
                  {coverSrc && (
                    <img
                      src={coverSrc}
                      alt={`${story.name} visszajelzése`}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                      style={{ objectPosition: "center top" }}
                    />
                  )}
                </div>
                <div className="px-6 py-5 text-center">
                  <p className="font-serif-display text-graphite text-[18px] md:text-[20px] leading-[1.3]">
                    {story.name}
                    {story.subtitle ? (
                      <span className="block mt-1 font-serif-display italic text-graphite-soft text-[13.5px]">
                        {story.subtitle}
                      </span>
                    ) : null}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-12 md:mt-14 text-center">
          <Link
            to="/visszajelzesek"
            data-testid={`${testIdPrefix}-testimonials-more-cta`}
            className="cta-gold-outline inline-flex items-center gap-3 px-8 py-3.5 text-[11.5px] md:text-[12px] uppercase font-body font-medium tracking-[0.22em]"
          >
            További visszajelzések
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
